module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00024.bea47b6.png";